import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { CSVLink } from 'react-csv';

import { useTranslation } from '@/hooks/use-translation';

interface CSVHeadersDataType {
  label: string;
  key: string;
}

interface Properties {
  data: Array<Record<string, unknown>>;
  headers: CSVHeadersDataType[];
  filename: string;
  style?: React.CSSProperties;
  fullWidth?: boolean;
  buttonText?: string;
  id?: string;
  onClick?: () => void;
}

const ExportCsvButton: React.FC<Properties> = (props) => {
  const { id, headers, data, filename, style, fullWidth, onClick, buttonText } = props;

  const { t } = useTranslation(['shared']);

  const theme = useTheme();

  if (!data) {
    return null;
  }

  const processedData = data.map((row) => {
    return Object.entries(row).reduce<typeof row>((processedRow, [key, value]) => {
      processedRow[key] = value instanceof Date ? value.getTime() : value;

      return processedRow;
    }, {});
  });

  return (
    <CSVLink
      onClick={onClick}
      data={processedData}
      headers={headers}
      filename={`${filename.toLocaleLowerCase()}.csv`}
      target="_blank"
      style={{ textDecoration: 'none', color: theme.palette.text.primary, margin: '10px', ...style }}
    >
      <Tooltip
        title={t(['shared:exportCsvTooltio'], {
          defaultValue: 'Export data to CSV. Only data displayed above is exported.',
        })}
      >
        <Button id={id} variant="contained" color="primary" fullWidth={fullWidth}>
          {buttonText ?? t(['shared:exportCsv'], { defaultValue: 'Export CSV' })}
        </Button>
      </Tooltip>
    </CSVLink>
  );
};

export default ExportCsvButton;
